import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AlertBannerComponent } from 'alert-banner-lib';
import { PendoService } from 'analytics-lib';
import { AwsRumService } from 'analytics-lib';
import { GoogleAnalyticsService } from 'analytics-lib';
import { Namespace } from 'enums-lib';
import { MessageAction, MessageNotificationService } from 'message-notification-service-lib';
import { Subscription } from 'rxjs';
import { Identity, IdentityStorage } from 'storage-service-lib';
import { environment } from '../environments/environment';
import { HamburgerWrapperComponent } from './components/hamburger-wrapper/hamburger-wrapper.component';
import { EntityTypeService } from './services/entity-type/entity-type.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'adv2-manager-ui';
  expandVersion = false;
  identity: Identity;
  notificationSub$: Subscription;
  namespaceClass = '';

  @ViewChild('alertBanner')
  alertBanner: AlertBannerComponent;

  @ViewChild(HamburgerWrapperComponent)
  hamburgerWrapper: HamburgerWrapperComponent;

  constructor(
    messageNotificationService: MessageNotificationService,
    private awsRumService: AwsRumService,
    private gaService: GoogleAnalyticsService,
    private pendoService: PendoService,
    private router: Router,
    private identityStorage: IdentityStorage,
    private entityTypeService: EntityTypeService,
  ) {
    this.notificationSub$ = messageNotificationService.message$.subscribe(({ message, action }) => {
      setTimeout(() => {
        if (action === MessageAction.SHOW) {
          this.alertBanner.show(message);
        } else if (action === MessageAction.HIDE) {
          this.alertBanner.hide(message);
        }
      }, 0);
    });

    this.subscribeToIdentityChanges();
  }

  ngOnInit(): void {
    this.initialiseAnalytics();
  }

  private initialiseAnalytics(): void {
    this.awsRumService.init();
    this.gaService.init();
    this.pendoService.initPendoScript(environment.pendoAPIKey);
  }

  private subscribeToIdentityChanges(): void {
    this.identityStorage.observe().subscribe((selectedIdentity) => {
      setTimeout(() => {
        this.identity = selectedIdentity;
        this.namespaceClass = this.getNamespaceClass();
      }, 0);

      if (selectedIdentity?.token) {
        // load entity label pairs when the user logs in
        // the identity changes several times after login, but the replay subject observables handle it
        this.entityTypeService.getEntitiesForNamespace(selectedIdentity.namespace);
      } else {
        this.entityTypeService.clear();
      }
    });
  }

  private getNamespaceClass(): string {
    if (this.identity) {
      return this.identity?.namespace + '-namespace';
    }

    const urlNamespace = Object.keys(Namespace).find((x) => this.router.url.includes(x));
    if (urlNamespace) {
      return urlNamespace + '-namespace';
    }

    return '';
  }

  ngOnDestroy(): void {
    if (this.notificationSub$) {
      this.notificationSub$.unsubscribe();
    }
  }
}
